import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],
      itemscount: {},

      addItem: (item) =>
        set((state) => {
          const newItemCount = { ...state.itemscount };

          if (newItemCount[item.id]) {
            newItemCount[item.id] += 1;
            return { itemscount: newItemCount };
          } else {
            newItemCount[item.id] = 1;
            return {
              items: [...state.items, item],
              itemscount: newItemCount,
            };
          }
        }),

      resetItems: () => set({ items: [], itemscount: {} }),

      removeItem: (id) =>
        set((state) => {
          const currentCount = state.itemscount[id] || 0;
          if (currentCount > 1) {
            const newItemCount = {
              ...state.itemscount,
              [id]: currentCount - 1,
            };
            return { itemscount: newItemCount };
          } else {
            const newItems = state.items.filter((item) => item.id !== id);
            const { [id]: _, ...newItemCount } = state.itemscount;
            return { items: newItems, itemscount: newItemCount };
          }
        }),

      // محاسبه تعداد کل آیتم‌ها در سبد خرید
      getTotalItems: () => {
        const counts = get().itemscount;
        return Object.values(counts).reduce((sum, count) => sum + count, 0);
      },
    }),
    {
      name: "cart-storage", // نام کلید در localStorage
      storage: createJSONStorage(() => localStorage), // استفاده از localStorage
      // در صورت نیاز می‌توانید از sessionStorage هم استفاده کنید:
      // storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default useCartStore;
